import React from 'react';
import { useStyles } from 'features/subscription/components/StatusHeader/style';
import { useTranslation } from 'hooks/useTranslation';
import { useHistory, useLocation } from 'react-router-dom';
import { subscriptionPaths } from 'features/subscription/routes/paths';
import { Typography } from '@material-ui/core';
import WarningIcon from 'assets/icons/warning.svg';

export const SubscriptionHeader: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation('subscription');
  const history = useHistory();
  const location = useLocation();

  const clickHandler = () => {
    const myPlansPath = subscriptionPaths.static.root;
    if (location.pathname !== myPlansPath) history.push(subscriptionPaths.static.root);
  };

  return (
    <div className={classes.statusWrapper}>
      <img src={WarningIcon} alt="status icon" />
      <Typography className={classes.statusText}>
        <span>{t('noSubscription.noActivePlans')}</span>
      </Typography>
      <Typography className={classes.link} onClick={clickHandler}>
        {t('noSubscription.subscribeNow')}
      </Typography>
    </div>
  );
};
